import { Controller } from '@hotwired/stimulus';

const STORAGE_KEY = 'smeasure_hide_access_entities_reminder_modal';

// Works alongside the generic "modal" controller (same element), which handles
// opening/closing the modal. This controller only decides whether the modal
// should open at all, and persists the "don't show again" choice on confirm —
// it never navigates: confirming just closes the modal and stays on this page.
export default class extends Controller {
  static targets = ['checkbox'];

  open(e) {
    if (this.isDismissed()) {
      // Skip the "modal" controller's toggleModal action bound after this one,
      // so the click falls through to the link's normal navigation.
      e.stopImmediatePropagation();
    }
  }

  confirm() {
    if (this.checkboxTarget.checked) {
      this.dismiss();
    }
  }

  isDismissed() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // localStorage unavailable (e.g. private browsing) — nothing to persist.
    }
  }
}
